import React from 'react';
import PropTypes from 'prop-types';

import AmbassadorImage from './AmbassadorImage';

import './Ambassador.css';

export default class Ambassador extends React.Component {
    static propTypes = {
        image: PropTypes.object.isRequired,
        fullName: PropTypes.string.isRequired,
        jobTitle: PropTypes.string.isRequired,
        quote: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        textLimit: PropTypes.number,
        expanded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        onReveal: PropTypes.func,
        onExpand: PropTypes.func,
    };

    static defaultProps = {
        expanded: true,
        textLimit: 120,
    };

    renderExpandingText() {
        const { text, expanded, textLimit } = this.props;
        const truncatedText = textLimit && text.substring(0, textLimit);

        if (text.length > textLimit && !expanded) {
            return (
                <p>
                    {truncatedText}…{' '}
                    <a
                        className="u-no-break"
                        href="#"
                        onClick={this.props.onExpand}
                    >
                        Les mer
                    </a>
                </p>
            );
        } else {
            return <p>{text}</p>;
        }
    }
    render() {
        const { image, fullName, jobTitle, quote, onReveal } = this.props;

        return (
            <div className="u-overflow-hidden u-word-break panel">
                <div className="u-text-center">
                    <AmbassadorImage imageUrl={image.urls.default} />
                </div>

                <blockquote className="blockquote u-mt16">{quote}</blockquote>

                <div className="header-text">
                    <div className="u-t4 fixedfontsize u-truncate u-strong">
                        {fullName}
                    </div>
                    <div className="u-d1 fixedfontsize u-truncate">
                        {jobTitle}
                    </div>
                    <div className="reveal-toggle">
                        <a
                            className="u-d1 u-no-break"
                            href="#"
                            onClick={onReveal}
                        >
                            Vis hele
                        </a>
                    </div>
                </div>

                {this.renderExpandingText()}

                {this.props.children}
            </div>
        );
    }
}
